import { Link } from "react-router-dom";
import Logo from "../components/Logo";
import "../css/LandingPage.css";

export default function UnauthorizedPage() {
  return (
    <main className="standalone-login">
      <section className="standalone-login-panel status-page" aria-labelledby="unauthorized-title">
        <Logo maxWidth="220px" marginBottom="1rem" />
        <p className="status-code">403</p>
        <h1 id="unauthorized-title">Unauthorized</h1>
        <p>Your account does not have permission to access this page.</p>
        <Link className="primary-action" to="/">
          Return home
        </Link>
      </section>
    </main>
  );
}
